import { View } from "binder"
import { BooleanViewModel } from "./boolean-viewModel"

export class BooleanView extends View<BooleanViewModel>{
    GetViewUniqueId(): string {
        return "V-ADD82F83-1C00-4F60-B0CF-3D4C449C692D"
    }
    loadHtml(): string {
        let element = require('./boolean.html').default;
        let style = require('./boolean.less');
        return element;
    }
    constructor() {
       super();
    }
    public set value(v: boolean) { this._value = v; } public get value(): boolean { return this._value;} private _value: boolean;

}
